
export const prefecturesData = [
  {
    id: 'nara',
    name: '奈良県',
    nameEn: 'NARA',
    region: '近畿',
    artistCount: 12,
    shopCount: 8,
    color: '#00ff41',
  },
];

export interface Shop {
  id: number;
  name: string;
  category: string;
  postalCode: string;
  address: string;
  lat: number;
  lng: number;
  description: string;
  color: string;
  thumbnail: string;
}

export const naraShops: Shop[] = [
  {
    id: 1,
    name: 'ECHO CHAMBER',
    category: 'ライブ',
    postalCode: '630-8226',
    address: '奈良市小西町8-1',
    lat: 34.678,
    lng: 135.825,
    description: 'キャパ80名のアンダーグラウンドライブスペース',
    color: '#ff006e',
    thumbnail: 'https://public.readdy.ai/ai/img_res/af7ced5704a2685e15695ac8e2cb4ebd.jpg',
  },
  {
    id: 2,
    name: 'NOISE CAFE LIVE',
    category: 'ライブ',
    postalCode: '630-8222',
    address: '奈良市餅飯殿町12',
    lat: 34.682,
    lng: 135.828,
    description: 'アコースティックライブとクラフトコーヒーが楽しめるライブスペース',
    color: '#ff006e',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20acoustic%20live%20music%20cafe%20interior%20with%20small%20stage%20area%20warm%20string%20lights%20hanging%20from%20ceiling%20craft%20coffee%20bar%20with%20espresso%20machine%20wooden%20furniture%20intimate%20atmosphere%20with%20pink%20neon%20accent%20lighting%20on%20walls&width=520&height=320&seq=shop2b&orientation=landscape',
  },
  {
    id: 3,
    name: 'DRIFT STUDIO',
    category: 'スタジオ',
    postalCode: '634-0007',
    address: '橿原市久米町564',
    lat: 34.509,
    lng: 135.793,
    description: 'レコーディング＆リハーサルスタジオ',
    color: '#00d9ff',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20professional%20music%20recording%20studio%20interior%20with%20mixing%20console%20and%20soundproof%20panels%20on%20walls%20cyan%20blue%20ambient%20LED%20lighting%20microphone%20in%20vocal%20booth%20visible%20through%20glass%20window%20modern%20audio%20equipment%20and%20monitors&width=520&height=320&seq=shop3b&orientation=landscape',
  },
  {
    id: 4,
    name: 'SOUND CRAFT STUDIO',
    category: 'スタジオ',
    postalCode: '630-8244',
    address: '奈良市三条町220',
    lat: 34.681,
    lng: 135.831,
    description: 'バンドリハーサル＆個人練習対応のレンタルスタジオ',
    color: '#00d9ff',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20band%20rehearsal%20studio%20with%20drum%20kit%20guitars%20amplifiers%20and%20microphones%20in%20a%20soundproofed%20room%20with%20blue%20LED%20strip%20lighting%20on%20ceiling%20clean%20professional%20practice%20space&width=520&height=320&seq=shop4b&orientation=landscape',
  },
  {
    id: 5,
    name: 'PULSE BAR & GRILL',
    category: '飲食店',
    postalCode: '630-8244',
    address: '奈良市三条町487',
    lat: 34.680,
    lng: 135.830,
    description: 'ライブミュージックが流れるダイニングバー',
    color: '#00ff41',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylish%20dining%20bar%20interior%20with%20warm%20ambient%20lighting%20wooden%20tables%20and%20counter%20seats%20music%20themed%20decor%20on%20walls%20green%20neon%20sign%20craft%20cocktails%20and%20food%20plates%20on%20bar%20counter%20cozy%20restaurant%20atmosphere&width=520&height=320&seq=shop5b&orientation=landscape',
  },
  {
    id: 6,
    name: 'VINYL DINER',
    category: '飲食店',
    postalCode: '630-8215',
    address: '奈良市東向中町15',
    lat: 34.685,
    lng: 135.832,
    description: 'レコードを聴きながら食事が楽しめるカフェレストラン',
    color: '#00ff41',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20retro%20themed%20cafe%20restaurant%20with%20vinyl%20records%20decorating%20the%20walls%20turntable%20playing%20music%20warm%20lighting%20comfortable%20booth%20seating%20delicious%20food%20on%20plates%20vintage%20music%20posters%20green%20accent%20lighting&width=520&height=320&seq=shop6b&orientation=landscape',
  },
  {
    id: 7,
    name: 'MIDNIGHT CLUB',
    category: 'クラブ',
    postalCode: '630-8223',
    address: '奈良市角振町26',
    lat: 34.683,
    lng: 135.829,
    description: 'テクノ・ハウスを中心としたナイトクラブ',
    color: '#b537f2',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dark%20nightclub%20interior%20with%20DJ%20booth%20and%20large%20speakers%20purple%20and%20magenta%20laser%20lights%20cutting%20through%20fog%20dance%20floor%20with%20modern%20lighting%20system%20underground%20techno%20house%20music%20club%20atmosphere&width=520&height=320&seq=shop7b&orientation=landscape',
  },
  {
    id: 8,
    name: 'GRIND WORKSHOP',
    category: '楽器店',
    postalCode: '630-0251',
    address: '生駒市東生駒1-70',
    lat: 34.694,
    lng: 135.710,
    description: 'エフェクター自作ワークショップ併設の楽器店',
    color: '#ff8c00',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20creative%20guitar%20pedal%20and%20effects%20workshop%20with%20workbench%20full%20of%20soldering%20tools%20and%20electronic%20components%20guitars%20hanging%20on%20wall%20warm%20amber%20lighting%20handmade%20effects%20pedals%20on%20display%20craft%20instrument%20shop&width=520&height=320&seq=shop8b&orientation=landscape',
  },
  {
    id: 9,
    name: 'TONE MUSIC STORE',
    category: '楽器店',
    postalCode: '630-8115',
    address: '奈良市大宮町4-250',
    lat: 34.686,
    lng: 135.820,
    description: 'ギター・ベース・シンセサイザー専門店',
    color: '#ff8c00',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20well%20organized%20music%20instrument%20store%20with%20electric%20guitars%20bass%20guitars%20and%20synthesizers%20displayed%20on%20walls%20and%20stands%20warm%20shop%20lighting%20professional%20music%20equipment%20keyboards%20and%20accessories%20on%20shelves&width=520&height=320&seq=shop9b&orientation=landscape',
  },
  {
    id: 10,
    name: 'WARP GALLERY',
    category: 'その他',
    postalCode: '632-0016',
    address: '天理市川原城町680',
    lat: 34.596,
    lng: 135.837,
    description: 'サウンドアート＆ビジュアルアート展示ギャラリー',
    color: '#ffd600',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20contemporary%20art%20gallery%20space%20with%20sound%20art%20installations%20and%20visual%20art%20pieces%20on%20white%20walls%20teal%20cyan%20neon%20accent%20lighting%20minimalist%20exhibition%20space%20with%20speakers%20and%20multimedia%20displays%20modern%20gallery%20interior&width=520&height=320&seq=shop10b&orientation=landscape',
  },
];
